'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdminsByCategoryPieService = function () {
  function AdminsByCategoryPieService($http) {
    'ngInject';

    _classCallCheck(this, AdminsByCategoryPieService);

    Object.assign(this, {
      $http: $http
    });
  }

  _createClass(AdminsByCategoryPieService, [{
    key: 'getReport',
    value: function getReport(params) {
      var pData = this.$http.get('/api/report/data_c_admin', {
        params: _extends({
          chartType: 'pie'
        }, params)
      });

      var pDrilldown = this.$http.get('/api/report/data_c_a_admin', {
        params: _extends({
          chartType: 'pie'
        }, params)
      });

      return Promise.all([pData, pDrilldown]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            pDataResult = _ref2[0],
            pDrilldownResult = _ref2[1];

        var series = pDataResult.data;
        var drilldown = { series: pDrilldownResult.data };

        return { series: series, drilldown: drilldown };
      });
    }
  }]);

  return AdminsByCategoryPieService;
}();

exports.default = AdminsByCategoryPieService;


// WEBPACK FOOTER //
// ./components/app/reports/admins-by-category-pie/admins-by-category-pie.service.js